import { HostBinding, Component } from '@angular/core';
import { BaseComponent } from './base.component';

@Component({
  template: '',
})
export class FauxModalComponent extends BaseComponent {
  @HostBinding('class.faux-modal') fauxModalClass = true;
}
